import { Link } from "react-router-dom";

export default function AdminEmails() {
  return (
    <div className="max-w-5xl mx-auto mt-10 p-6">
      <h1 className="text-3xl font-bold text-sky-400 mb-6">📧 E-Mail-System</h1>
      <p className="mb-8 text-slate-400">
        Verwalte hier die E-Mail-Vorlagen, Regeln, Versand-Queue und die
        Zustellhistorie. Diese Funktionen sind aktuell nur für Admins sichtbar.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        <Link
          to="/admin/emails/templates"
          className="block bg-[#161b27] border border-[#2a3347] rounded-lg p-6 hover:border-sky-500/20 transition-colors"
        >
          <h2 className="text-xl font-semibold mb-2 text-slate-100">📑 Templates</h2>
          <p className="text-slate-400">
            Vorlagen erstellen, bearbeiten und Vorschau ansehen.
          </p>
        </Link>

        <Link
          to="/admin/emails/rules"
          className="block bg-[#161b27] border border-[#2a3347] rounded-lg p-6 hover:border-sky-500/20 transition-colors"
        >
          <h2 className="text-xl font-semibold mb-2 text-slate-100">⚙️ Regeln</h2>
          <p className="text-slate-400">
            Trigger und Bedingungen konfigurieren, wann welche Mails gesendet
            werden.
          </p>
        </Link>

        <Link
          to="/admin/emails/queue"
          className="block bg-[#161b27] border border-[#2a3347] rounded-lg p-6 hover:border-sky-500/20 transition-colors"
        >
          <h2 className="text-xl font-semibold mb-2 text-slate-100">📬 Queue</h2>
          <p className="text-slate-400">
            Übersicht der geplanten und wartenden E-Mails.
          </p>
        </Link>

        <Link
          to="/admin/emails/sends"
          className="block bg-[#161b27] border border-[#2a3347] rounded-lg p-6 hover:border-sky-500/20 transition-colors"
        >
          <h2 className="text-xl font-semibold mb-2 text-slate-100">📊 Versandhistorie</h2>
          <p className="text-slate-400">
            Gesendete E-Mails mit Zustell- und Trackinginformationen.
          </p>
        </Link>

        <Link
          to="/admin/emails/test"
          className="block bg-[#161b27] border border-[#2a3347] rounded-lg p-6 hover:border-sky-500/20 transition-colors"
        >
          <h2 className="text-xl font-semibold mb-2 text-slate-100">🧪 Test-Board</h2>
          <p className="text-slate-400">
            Flags & Modi setzen, Evaluator & Sender aus der UI triggern.
          </p>
        </Link>
      </div>

      <div className="mt-6 p-4 border border-[#2a3347] rounded-xl bg-[#161b27]">
        <h2 className="font-semibold text-lg text-sky-400 mb-2">Kurzanleitung (GUI-Test)</h2>
        <ol className="list-decimal pl-5 space-y-1 text-sm text-slate-300">
          <li>Lege unter <strong>Templates</strong> eine Vorlage an (aktiv, ggf. Tracking).</li>
          <li>Lege unter <strong>Regeln</strong> eine passende Regel an (z. B. Zero-Progress, Delay 2h, aktiv).</li>
          <li>Hier im Test-Board:
            <ul className="list-disc pl-5">
              <li><em>Modus</em> auf <strong>dry_run</strong> lassen → <em>Dry-Run Evaluator</em> testen (keine Writes).</li>
              <li><em>Queue-Writes</em> auf <strong>true</strong> → <em>Queue-Write Evaluator</em> klicken (schreibt in Queue).</li>
              <li>Modus <strong>sandbox</strong> setzen und <strong>Sandbox-Recipient</strong> eintragen.</li>
              <li>In der <strong>Queue</strong> einen Eintrag „Jetzt senden" fällig machen → hier <em>Sender starten</em>.</li>
            </ul>
          </li>
          <li>Öffne die Mail im Sandbox-Postfach → <strong>opened</strong> in der <em>Versandhistorie</em> prüfen.</li>
          <li>Klicke den Link → <strong>clicked</strong> Event erscheint im Send-Detail.</li>
          <li>Zum Abschluss: Modus wieder <strong>dry_run</strong>, Queue-Writes <strong>false</strong>, Cap ggf. zurücksetzen.</li>
        </ol>
      </div>

    </div>
  );
}
